









/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import CardCanvas from '@/layouts/card-canvas.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default Vue.extend({
  name: 'GlobalTaskCreate',

  components: {
    CardCanvas,
  },

  data() {
    return {
      RouteAssistant,
    }
  },

  computed: {
    projectID(): Number {
      return Number(this.$route.params.id)
    },
  },

  metaInfo: {
    title: 'New Task',
  },

  mounted() {},

  methods: {
    handleTaskCreated(projectID: number, id: number, createAnother: boolean) {
      if (!createAnother) {
        RouteAssistant.goToTask(
          this.$router,
          this.$route.params.accountId,
          projectID,
          id,
          this.$permissions,
        )
      }
    },
  },
})
